import { render, staticRenderFns } from "./message-send-list.vue?vue&type=template&id=0ae0ee2e"
import script from "./message-send-list.vue?vue&type=script&lang=ts"
export * from "./message-send-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports